export default "__VITE_ASSET__BGZWDTp2__"